import { useReducer } from '@olxeu-a2b/delivery-utils/src/extras';
import { useMemo } from 'react';
import * as actionCreators from '../order-store/action-creators';
import orderReducer, { getInitialState } from '../order-store/orderReducer';
import { OrderStore } from '../order-store/order-store';

export type Methods = {
  [key in keyof typeof actionCreators]: ReturnType<typeof actionCreators[key]>;
};

export default (adId: string, orderId?: string) => {
  const [state, dispatch] = useReducer(orderReducer, getInitialState(adId, orderId));

  const methods = useMemo(
    () =>
      Object.entries(actionCreators).reduce(
        (funcs, [methodName, method]) => ({
          ...funcs,
          [methodName]: method(dispatch),
        }),
        {} as Methods,
      ),
    [],
  );

  return {
    state: state as OrderStore,
    ...methods,
  };
};
